import { LvisionBetBoosterApiKeys } from '../types';

export const lvisionBetBoosterApiKeys: LvisionBetBoosterApiKeys = {
  prod: 'dn5lkp1rdng5mdt2v00pyl0y',
  dev: 'd93p27e8k3i2wqo7wmoz472t'
};
